import { render } from "./RightDetail.vue?vue&type=template&id=7ec09430"
import script from "./RightDetail.vue?vue&type=script&lang=js"
export * from "./RightDetail.vue?vue&type=script&lang=js"

import "./RightDetail.vue?vue&type=style&index=0&id=7ec09430&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__